module.exports = __webpack_public_path__ + "static/img/1.a0618f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/1.png
// module id = nWKo
// module chunks = 0